import {
  STUDY,
  STUDY_DETAIL,
  ADD_STUDY,
  EDIT_STUDY,
  DELETE_STUDY,
} from "../actions/Actions";

const initalState = {
  listLoader: false,
  listCount: null,
  list: [],
  addLoader: false,
  deleteLoader: false,
  detail: null,
  detailLoader: false,
  editLoader: false,
};

export function studyReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    case STUDY.LOADING:
      return {
        ...state,
        listLoader: true,
      };
    case STUDY.SUCCESS:
      return {
        ...state,
        listLoader: false,
        listCount: payload.total,
        list: payload.rows,
      };
    case STUDY.ERROR:
      return {
        ...state,
        listLoader: false,
      };

    // GET DETAIL
    case STUDY_DETAIL.LOADING:
      return {
        ...state,
        detailLoader: true,
        detail: null,
      };
    case STUDY_DETAIL.SUCCESS:
      return {
        ...state,
        detailLoader: false,
        detail: payload,
      };
    case STUDY_DETAIL.ERROR:
      return {
        ...state,
        detailLoader: false,
      };

    //  ADD
    case ADD_STUDY.LOADING:
      return {
        ...state,
        addLoader: true,
      };
    case ADD_STUDY.SUCCESS:
      return {
        ...state,
        addLoader: false,
      };
    case ADD_STUDY.ERROR:
      return {
        ...state,
        addLoader: false,
      };

    //  edit
    case EDIT_STUDY.LOADING:
      return {
        ...state,
        editLoader: true,
      };
    case EDIT_STUDY.SUCCESS:
      return {
        ...state,
        editLoader: false,
      };
    case EDIT_STUDY.ERROR:
      return {
        ...state,
        editLoader: false,
      };
    // DELETE
    case DELETE_STUDY.LOADING:
      return {
        ...state,
        deleteLoader: true,
      };
    case DELETE_STUDY.SUCCESS:
      return {
        ...state,
        deleteLoader: false,
      };
    case DELETE_STUDY.ERROR:
      return {
        ...state,
        deleteLoader: false,
      };
    default:
      return state;
  }
}
